/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResponsiblePersonEmail/view.blocks to change it.
import Checkbox from 'DesignSystem/Checkbox/index'
import Input from 'DesignSystem/Input/index'
import PreviousQuestion from './PreviousQuestion/index'
import Question from 'DesignSystem/Question/index'
import React from 'react'
import Status from './Status/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function ResponsiblePersonEmail({
  children,
  viewPath = "/App/Form/Data/ProvideData/ResponsiblePersonEmail",
  onChange,
  onSubmit,
  value,
  usePatientEmail,
  onClickUsePatientEmail
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="ResponsiblePersonEmail.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-Z2a0qfK': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="ResponsiblePersonEmail.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<PreviousQuestion
  viewPath={`${viewPath}/PreviousQuestion`}
/>
<Question
  viewPath={`${viewPath}/Question`}
 marginBottom={0}
 marginTop={4}
 text="What is the email address of the person responsible for the patient?"
/>
</div>
<Input
  viewPath={`${viewPath}/Input`}
 autoFocus={true}
 onChange={onChange}
 onSubmit={onSubmit}
 placeholder="i.e. name@email.com"
 type="email"
 value={value}
 textTransform="none"
/>
<Checkbox
  viewPath={`${viewPath}/Checkbox`}
 isSelected={usePatientEmail}
 marginTop={16}
 onClick={onClickUsePatientEmail}
 text="Use Patient Email"
/>
<Status
  viewPath={`${viewPath}/Status`}
 onSubmit={onSubmit}
/>
</div>
{children}
</React.Fragment>)
}